export const cn = {
    solutionCard: {
        owner: '所有者',
        PAPER: {
            PBD: '出版日期',
        },
        PATENT: {
            APD: '申请日期',
            PBD: '公开日期',
        },
        NEWS: {
            PBD: '发布日期',
        },
        ai_summary: 'AI 核心要点',
    },
}

export const en = {
    solutionCard: {
        owner: 'Owner',
        PAPER: {
            PBD: 'Public Date',
        },
        PATENT: {
            APD: 'Application Date',
            PBD: 'Publication Date',
        },
        NEWS: {
            PBD: 'Public Date',
        },
        ai_summary: 'AI Summary',
    },
}

export const jp = {
    solutionCard: {
        owner: '所有者',
        PAPER: {
            PBD: '出版日',
        },
        PATENT: {
            APD: '申請日',
            PBD: '公開日',
        },
        NEWS: {
            PBD: '発表日',
        },
        ai_summary: 'AI 要約',
    },
}

export const tw = {
    solutionCard: {
        owner: '所有者',
        APD: '申請日期',
        PAPER: {
            PBD: '出版日期',
        },
        PATENT: {
            APD: '申請日期',
            PBD: '公開日期',
        },
        NEWS: {
            PBD: '發佈日期',
        },
        ai_summary: 'AI 核心要點',
    },
}
